import { redirect, useLocation, useNavigate } from 'react-router-dom'
import React, {useState, useEffect} from "react";
import SideBar from "../components/SideBar";
import VerifyForm from "../components/VerifyForm";
import MobileSteps from "../components/MobileSteps";
import PersonalInfoForm from "../components/PersonalInfoForm";
import Footer from "../shared/Footer";



export default function PersonalInfo () {

    const navigate = useNavigate();
    const location = useLocation();

    document.title = 'Get a Handicap - Personal Information';
    const screensize = window.innerWidth;

    const [windowWidth, setWindowWidth] = useState(0);
    const [windowHeight, setWindowHeight] = useState(0);
    let resizeWindow = () => {
      setWindowWidth(window.innerWidth);
      setWindowHeight(window.innerHeight);
    };
  
    useEffect(() => {
      resizeWindow();
      window.addEventListener("resize", resizeWindow);
      return () => window.removeEventListener("resize", resizeWindow);
    }, []);

    return (<>

{location.state ?
        
       <div className="container App_container">
            <div className="row col-10 mx-auto">
       {screensize > 992 ? 
       <>
            <div className="col-12 col-sm-5 col-md-3 col-lg-3 col-xl-3 col-xxl-3" id="navigation_container">
                <SideBar />
            </div>
            <div className="col-12 col-sm-12 col-md-12 col-lg-9 col-xl-9 col-xxl-9" id="navigation_container">
                <PersonalInfoForm />
            </div>
        </> : '' }
        </div>
        {screensize <= 1024 ?
        <> 
        <div className="col-12 col-sm-12 col-md-12 col-lg-12 col-xl-12" id="navigation_mobile_container">
            <MobileSteps />
        </div>
        <div className="col-12 col-md-12" id="navigation_mobile_container" >
            <PersonalInfoForm />
        </div>
        </>
            :''}
        
      
    </div> : '' }
    </>


    )
}
